import { combineReducers } from 'redux';
import commonReducer from './commonReducer';
import contactsReducer from './contactsReducer';

const rootReducer = combineReducers({
    common: commonReducer,
    contacts: contactsReducer,
});

export default rootReducer;
